module.exports = __webpack_public_path__ + "static/media/ic_conduite_grue.ff6bf0a6.svg";